var steps = {
  step1: null,
  step2: null,
  step3: null,
};
const EN_KEYBOARD_CONFIG = [
  ['1','2','3','4','5','6','7','8','9','0'],
  ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
  ['a','s','d','f','g','h','j','k','l'],
  ['z','x','c','v','b','n','m'],
];
const ALLOWED_NON_ALPHA_CHARACTERS = "!&?1234567890"
const MOBILE_BREAKPOINT = 1199.98;
const LOCK_HANDLE_TO_ICON = {
  'heart-icon': "❤️",
};
const CHAIN_MAP = {};
const US_DOLLAR = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

window.localStorage.setItem("chainLength", "5.5\"");
window.localStorage.setItem("loopMaterial", "Yellow Gold");
window.localStorage.setItem("charmMaterial", "Yellow Gold");
window.localStorage.setItem("characterQuantity", "3");
window.localStorage.setItem("currentStep", "step-1");
window.localStorage.setItem("chainPrice", "0.00");
setSelectedCharacters([]);

function getSelectedCharacters() {
  return JSON.parse(window.localStorage.getItem("selectedCharacters"));
}

function setSelectedCharacters(value) {
  return window.localStorage.setItem("selectedCharacters", JSON.stringify(value));
}

function getSelectedChain() {
  const variantName = [
    window.localStorage.getItem("chainLength"),
    window.localStorage.getItem("productId"),
  ].join(",");

  return CHAIN_VARIANT_MAP[variantName];
}

function getSelectedLoop() {
  return LOOP_VARIANT_MAP[window.localStorage.getItem("loopMaterial")];
}

function getSelectedChainPrice() {
  const variant = getSelectedChain()
  return variant ? parseInt(variant.price) : 0
}

function getCharmPriceTotal() {
  const selectedCharacters = getSelectedCharacters();
  let charmPriceTotal = 0;
  Array(selectedCharacters.length).fill(0).forEach((_, index) => {
    const position = (index === 0 ? "First" : (index === selectedCharacters.length - 1 ? "Last" : "Middle"));
    const lockLetterEl = document.querySelector('[data-lock-character="' + selectedCharacters[index].character + '"][data-lock-position="' + position + '"][data-charm-material="' + selectedCharacters[index].material + '"]');
    const productId = lockLetterEl.dataset.productId;
    const charmVariantId = [position,selectedCharacters[index].material,productId].join(",");
    const charmVariant = CHARM_VARIANT_MAP[charmVariantId];
    if (charmVariant) {
      charmPriceTotal += parseInt(charmVariant.price)
    }
  });
  return charmPriceTotal;
}

function clearEl(el) {
  while (el.firstChild) {
    el.removeChild(el.lastChild);
  }
}

function isMobile() {
  return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) <= MOBILE_BREAKPOINT;
}

function renderCharacters(containerEl, selectedCharacters, maxLength) {
  clearEl(containerEl);
  Array(maxLength).fill(0).forEach((_, index) => {
    var chosenLetterEl = document.createElement("span");
    chosenLetterEl.className = "chosen-letter";
    if (selectedCharacters[index]) {
      const position = (index === 0 ? "First" : (index === selectedCharacters.length - 1 ? "Last" : "Middle"));
      const lockLetterEl = document.querySelector('[data-lock-character="' + selectedCharacters[index].character + '"][data-lock-position="' + position + '"][data-charm-material="' + selectedCharacters[index].material + '"] figure');
      if (selectedCharacters[index].character.length === 1) {
        chosenLetterEl.innerHTML = selectedCharacters[index].character;
      } else if (LOCK_HANDLE_TO_ICON[selectedCharacters[index].character]) {
        chosenLetterEl.innerHTML = LOCK_HANDLE_TO_ICON[selectedCharacters[index].character]
      } else if (lockLetterEl) {
        chosenLetterEl.appendChild(lockLetterEl.cloneNode(true));
      }
    }
    chosenLetterEl.onclick = () => {
      const hiddenInput = document.querySelector('#chosen-letters-input');
      hiddenInput.focus();
    };
    chosenLetterEl.ontouchstart = () => {
      const hiddenInput = document.querySelector('#chosen-letters-input');
      hiddenInput.focus();
    }
    containerEl.appendChild(chosenLetterEl);
  });
}

function renderFloatingCharacters(inputContainerEl, selectedCharacters) {
  let containerEl = inputContainerEl;
  clearEl(containerEl);

  Array(selectedCharacters.length).fill(0).forEach((_, index, arr) => {
    const position = (index === 0 ? "First" : (index === selectedCharacters.length - 1 ? "Last" : "Middle"));
    const lockLetterEl = document.querySelector('[data-lock-character="' + selectedCharacters[index].character + '"][data-lock-position="' + position + '"][data-charm-material="' + selectedCharacters[index].material + '"] figure');

    if (!lockLetterEl) {
      return;
    }

    var chosenLetterEl = document.createElement("span");
    chosenLetterEl.classList.add('floating-character');
    if (position === "Middle") {
      chosenLetterEl.classList.add('floating-character-middle');
    } else if (position === "Last") {
      chosenLetterEl.classList.add('floating-character-last');
    } else if (position === "First") {
      chosenLetterEl.classList.add('floating-character-first');
    }
    chosenLetterEl.appendChild(lockLetterEl.cloneNode(true));
    containerEl.appendChild(chosenLetterEl);
    containerEl = chosenLetterEl;

    if (index === arr.length - 1) {
      const loopMaterial = window.localStorage.getItem('loopMaterial');
      let loopImageEl = document.querySelector(`.loop-images [data-loop-material="${loopMaterial}"]`);
      if (loopImageEl) {
        loopImageEl = loopImageEl.cloneNode(true);
        loopImageEl.classList.remove('hide');
        containerEl.appendChild(loopImageEl);
      }
    }
  });
}

function renderCart() {
  // render chain
  const selectedProductId = window.localStorage.getItem("productId");
  const selectedChain = CHAIN_MAP[selectedProductId]
  const customCartItemTitleEl = document.querySelector('.custom-cart-item-title');
  const customCartItemImageEl = document.querySelector('.custom-cart-item-image');
  const customCartItemPriceEl = document.querySelector('.custom-cart-item-price');
  const targetImageEl = document.querySelector('.chain[data-product-id="' + selectedProductId + '"] figure');
  if (customCartItemTitleEl && selectedChain) {
    customCartItemTitleEl.innerHTML = selectedChain.title;
    
    if (customCartItemImageEl.firstChild) {
      customCartItemImageEl.removeChild(customCartItemImageEl.lastChild);
    }
    customCartItemImageEl.appendChild(targetImageEl.cloneNode(true));
  }

  if (customCartItemPriceEl) {
    customCartItemPriceEl.innerHTML = US_DOLLAR.format(getSelectedChainPrice() / 100);
  }
  
  // render charms
  let cartItem;
  const customCartLocksEl = document.querySelector('.custom-cart-locks');
  clearEl(customCartLocksEl);
  const selectedCharacters = getSelectedCharacters();
  Array(selectedCharacters.length).fill(0).forEach((_, index) => {
    const position = (index === 0 ? "First" : (index === selectedCharacters.length - 1 ? "Last" : "Middle"));
    const lockLetterEl = document.querySelector('[data-lock-character="' + selectedCharacters[index].character + '"][data-lock-position="' + position + '"][data-charm-material="' + selectedCharacters[index].material + '"]');
    const productId = lockLetterEl.dataset.productId;
    const charmVariantId = [position,selectedCharacters[index].material,productId].join(",");
    const charmVariant = CHARM_VARIANT_MAP[charmVariantId];

    const cartLockTemplateEl = document.querySelector('#cart-lock');
    if (!cartLockTemplateEl) {
      return;
    }

    cartItem = cartLockTemplateEl.content.cloneNode(true);
    const cartItemImage = cartItem.querySelector('.custom-cart-item-image');
    const cartItemTitle = cartItem.querySelector('.custom-cart-item-title');
    const cartItemCharmMaterial = cartItem.querySelector('.custom-cart-item-charm-material');
    const cartItemLockPrice = cartItem.querySelector('.custom-cart-item-price');
    cartItemTitle.innerHTML = `${selectedCharacters[index].character} Character`;
    cartItemLockPrice.innerHTML = US_DOLLAR.format(charmVariant.price / 100);

    if (lockLetterEl.querySelector("figure")) {
      cartItemImage.appendChild(lockLetterEl.querySelector("figure").cloneNode(true));
    }
    cartItemCharmMaterial.innerHTML = selectedCharacters[index].material;
    customCartLocksEl.appendChild(document.querySelector('.divider').cloneNode());
    customCartLocksEl.appendChild(cartItem);
  });

  // render total
  const cartSubtotal = document.querySelector('.custom-cart-subtotal-value');
  if (cartSubtotal) {
    cartSubtotal.innerHTML = US_DOLLAR.format((getSelectedChainPrice() + getCharmPriceTotal()) / 100);
  }

  if (canSubmit()) {
    disableSubmit(false);
  } else {
    disableSubmit(true);
  }
}

function renderAllCharacters() {
  const selectedCharacters = getSelectedCharacters();
  const maxLength = parseInt(window.localStorage.getItem("characterQuantity"), 10);
                                                
  const floatingCharactersEl = document.querySelector(".floating-characters");
  if (floatingCharactersEl) {
    renderFloatingCharacters(floatingCharactersEl, selectedCharacters);
  }
  const chosenLettersEl = document.querySelector(".chosen-letters");
  if (chosenLettersEl) {
    renderCharacters(chosenLettersEl, selectedCharacters, maxLength);
  }
}

function renderPreview() {
  const containerEl = document.querySelector(".preview-image");
  let floatingCharactersEl = document.querySelector(".floating-characters");
  if (!floatingCharactersEl) {
    floatingCharactersEl = document.createElement('div');
    floatingCharactersEl.classList.add('floating-characters');
  }

  const previousImage = containerEl.querySelector('.preview-image-lock-count')
  if (previousImage) {
    containerEl.removeChild(previousImage);
  }
  
  const selectedProductId = parseInt(window.localStorage.getItem("productId"), 10);
  const characterQuantity = parseInt(window.localStorage.getItem("characterQuantity"), 10);
  const previewTitle = document.querySelector('.product-preview-title');
  let posX, posY;
  if (previewTitle) {
    previewTitle.innerHTML = CHAIN_MAP[selectedProductId].title;
  }
  const previewImageEls = document.querySelectorAll('.preview-image-lock-count[data-product-id="' + selectedProductId + '"]');
  if (previewImageEls) {
    let selectedPreviewImageEl, selectedPreviewImageLockCount, previewImageLockCount
    const sortedPreviewEls = Array.from(previewImageEls).sort((a, b) => {
      previewImageLockCountA = a.dataset.previewImageLockCount ? parseInt(a.dataset.previewImageLockCount, 10) : 3;
      previewImageLockCountB = b.dataset.previewImageLockCount ? parseInt(b.dataset.previewImageLockCount, 10) : 3;
      return previewImageLockCountA - previewImageLockCountB;
    });
    sortedPreviewEls.forEach((previewImageEl) => {
      previewImageLockCount = previewImageEl.dataset.previewImageLockCount ? parseInt(previewImageEl.dataset.previewImageLockCount, 10) : 3;
      if (previewImageLockCount >= characterQuantity && !selectedPreviewImageEl) {
        selectedPreviewImageEl = previewImageEl;
      }
    });
    if (selectedPreviewImageEl) {
      const clonedPreview = selectedPreviewImageEl.cloneNode(true);
      clonedPreview.appendChild(floatingCharactersEl);
      containerEl.appendChild(clonedPreview);
      posX = selectedPreviewImageEl.dataset.focalPointX;
      posY = selectedPreviewImageEl.dataset.focalPointY;
    }
  }

  // magic offset of 32px comes from the width of the charm and the width of the icon used when placing the focal point in shopify
  floatingCharactersEl.style = `
    left: ${posX}%;
    top: calc(${posY}% - ${isMobile() ? '12px' : '17px' });
  `;
}

function renderCharms() {
  const selectedcharmMaterial = window.localStorage.getItem("charmMaterial");
  const alphabetKeyboardEl = document.querySelector(".alphabet-keyboard");
  const selectedCharacters = getSelectedCharacters();
  
  if (alphabetKeyboardEl) {
    clearEl(alphabetKeyboardEl);
    alphabetKeyboardEl.innerHTML = 'Characters';
    
    const charmCollectionList = document.querySelectorAll('[data-lock-collection-handle]');
    let charmEls;
    let collectionEl;
    EN_KEYBOARD_CONFIG.forEach((keyboardRow) => {
      const rowEl = document.createElement('div');
      rowEl.classList.add('charm-row', 'alphanum-row');
      keyboardRow.forEach((alphaNum) => {
        let lockLetterEl = document.querySelector('button.lock[data-lock-character="' + alphaNum.toUpperCase() + '"][data-charm-material="' + selectedcharmMaterial + '"]');
        if (lockLetterEl) {
          lockLetterEl = lockLetterEl.cloneNode(true);
        } else {
          lockLetterEl = document.querySelector('button.lock').cloneNode();
          lockLetterEl.innerHTML = alphaNum;
          lockLetterEl.dataset.lockCharacter = alphaNum.toUpperCase();
        }
        if (selectedCharacters.find(({ character }) => {
          return character === alphaNum.toUpperCase();
        })) {
          lockLetterEl.classList.add('selected');
        }
        rowEl.appendChild(lockLetterEl);
      });
      alphabetKeyboardEl.appendChild(rowEl);
    });
    
    const gemstonesEl = document.querySelector(".gemstones");
    clearEl(gemstonesEl);
    gemstonesEl.innerHTML = 'Gemstones';
    charmCollectionList.forEach((charmCollectionEl) => {
      if (['talking-chains-numbers', 'talking-chains-characters'].includes(charmCollectionEl.dataset.lockCollectionHandle)) {
        return;
      }

      if (['talking-chains-gemstones'].includes(charmCollectionEl.dataset.lockCollectionHandle)) {
        charmEls = charmCollectionEl.querySelectorAll('[data-charm-material="Yellow Gold"][data-lock-position="First"]');
        collectionEl = document.createElement('div');
        collectionEl.classList.add('charm-row');
        charmEls.forEach((charmEl) => {
          const clonedCharm = charmEl.cloneNode(true);
          if (selectedCharacters.find(({ character, material }) => {
            return character === clonedCharm.dataset.lockCharacter && material === clonedCharm.dataset.charmMaterial;
          })) {
            clonedCharm.classList.add('selected');
          }
          collectionEl.appendChild(clonedCharm);
        });
        let gemstoneTitle = document.createElement('div');
        gemstoneTitle.classList.add('gemstone-title');
        gemstoneTitle.innerHTML = 'Yellow Gold <span style="display:inline-block; width: 15px; height: 15px; background-color: #CCB03A; border-radius: 50%; margin-left: 8px;"></span>';
        gemstonesEl.appendChild(gemstoneTitle);
        gemstonesEl.appendChild(collectionEl);
        
        charmEls = charmCollectionEl.querySelectorAll('[data-charm-material="Rose Gold"][data-lock-position="First"]');
        collectionEl = document.createElement('div');
        collectionEl.classList.add('charm-row');
        charmEls.forEach((charmEl) => {
          const clonedCharm = charmEl.cloneNode(true);
          if (selectedCharacters.find(({ character, material }) => {
            return character === clonedCharm.dataset.lockCharacter && material === clonedCharm.dataset.charmMaterial;
          })) {
            clonedCharm.classList.add('selected');
          }
          collectionEl.appendChild(clonedCharm);
        });
        gemstoneTitle = document.createElement('div');
        gemstoneTitle.classList.add('gemstone-title');
        gemstoneTitle.innerHTML = 'Rose Gold <span style="display:inline-block; width: 15px; height: 15px; background-color: #DCC3B9; border-radius: 50%; margin-left: 8px;"></span>';
        gemstonesEl.appendChild(gemstoneTitle);
        gemstonesEl.appendChild(collectionEl);
      } else if (['talking-chains-icons'].includes(charmCollectionEl.dataset.lockCollectionHandle)) {
        charmEls = charmCollectionEl.querySelectorAll('[data-charm-material="' + selectedcharmMaterial + '"][data-lock-position="First"]');
        collectionEl = document.createElement('div');
        collectionEl.classList.add('charm-row', 'alphanum-row');
        charmEls.forEach((charmEl) => {
          const clonedCharm = charmEl.cloneNode(true);
          if (selectedCharacters.find(({ character }) => {
            return character === clonedCharm.dataset.lockCharacter;
          })) {
            clonedCharm.classList.add('selected');
          }
          collectionEl.appendChild(clonedCharm);
        });
        alphabetKeyboardEl.appendChild(collectionEl);
      }
    });
  }

  const charms = document.querySelectorAll('button.lock');
  charms.forEach((charm) => {
    if (isMobile()) {
      charm.addEventListener('touchend', selectLock);
    } else {
      charm.addEventListener('click', selectLock);
    }
  });
}

function renderCharacterQuantityValues() {
  var characterQuantitysContainerEl = document.querySelector('.character-quantity-values');
  clearEl(characterQuantitysContainerEl);

  if (isMobile()) {
    const characterQuantitySelect = document.createElement('select');
    characterQuantitySelect.addEventListener('change', handleCharacterQuantityChange)
    characterQuantitysContainerEl.appendChild(characterQuantitySelect)
    characterQuantitysContainerEl = characterQuantitySelect;
    characterQuantitySelect.classList.add('character-quantity-select');
    characterQuantitysContainerEl.addEventListener("touchstart", () => {
      characterQuantitySelect.focus();
    });
  }
  
  if (characterQuantitysContainerEl) {
    Array(8).fill(0).forEach((_, index) => {
      var characterQuantityEl;
      if (isMobile()) {
        characterQuantityEl = document.createElement("option");
      } else {
        var characterQuantityEl = document.createElement("button");
      }
      characterQuantityEl.classList.add('character-quantity-value');
      if (index === 0) {
        characterQuantityEl.classList.add('active');
      }
      characterQuantityEl.innerHTML = 3 + index;
      characterQuantityEl.dataset.characterQuantity = 3 + index;
      characterQuantityEl.addEventListener('click', handleCharacterQuantityChange);
      characterQuantityEl.addEventListener('touchstart', handleCharacterQuantityChange);
      characterQuantitysContainerEl.appendChild(characterQuantityEl);
    });
  }
}

function renderChainImages() {
  const chainImageEls = document.querySelectorAll('.chain-image');
  const selectedProductId = window.localStorage.getItem("productId");
  const selectedProductImage = document.querySelector('.chain[data-product-id="' + selectedProductId + '"] figure');
  if (selectedProductImage) {
    chainImageEls.forEach((chainImageEl) => {
      clearEl(chainImageEl);
      chainImageEl.appendChild(selectedProductImage.cloneNode(true));
    });
  }
}

function renderCharmMaterialSelections() {
  const charmImageEls = document.querySelectorAll('.charm-image');
  charmImageEls.forEach((charmImageEl) => {
    const charmAImageEl = document.querySelector('button.lock[data-lock-character="A"][data-lock-position="First"][data-charm-material="' + charmImageEl.dataset.charmMaterial + '"] figure');
    charmImageEl.appendChild(charmAImageEl.cloneNode(true));
  });
}

function initChains(chains) {
  chains.forEach((chain) => {
    CHAIN_MAP[chain.id] = chain;
    chain.variants.forEach((variant) => {
      CHAIN_MAP[variant.id] = variant;
      CHAIN_MAP[variant.id].product_id = chain.id;
    });
  });
}

function disableSubmit(submitDisabled) {
  const submitButton = document.querySelector('.custom-cart-submit');
  const nextButtons = document.querySelectorAll('.next-button');
  if (submitButton) {
    submitButton.disabled = submitDisabled;
  }
  if (window.localStorage.getItem('currentStep') === 'step-3') {
    nextButtons.forEach((nextButton) => {
      nextButton.disabled = submitDisabled;
    });
  }
}

function handleCharacterQuantityChange(e) {
  e.preventDefault();
  characterQuantity = parseInt(e.target.selectedOptions ? e.target.selectedOptions[0].dataset.characterQuantity : e.target.dataset.characterQuantity, 10);
  window.localStorage.setItem("characterQuantity", characterQuantity);
  var currentlySelectedCharacterQuantityEl = document.querySelector('.character-quantity-value.active');
  if (currentlySelectedCharacterQuantityEl) {
    currentlySelectedCharacterQuantityEl.classList.remove('active');
  }

  const selectedCharacters = getSelectedCharacters();
  setSelectedCharacters(selectedCharacters.slice(0, characterQuantity));
  
  e.target.classList.add('active');

  renderCharms();
  renderAllCharacters();
  renderPreview();
  renderCart();
}
const handleTouchEvents = (e) => {
  var selectedCharacters = getSelectedCharacters();
  const characterQuantity = parseInt(window.localStorage.getItem("characterQuantity"), 10);
  const hiddenInput = document.querySelector("#chosen-letters-input");
  if (e.code === "Backspace" || e.key === "Backspace") {
    selectedCharacters = selectedCharacters.slice(0, -1);
  } else if (
      (
        ALLOWED_NON_ALPHA_CHARACTERS.includes(e.key) ||
        (e.keyCode > 64 && e.keyCode < 91) || // upper alpha (A-Z)
        (e.keyCode > 96 && e.keyCode < 123) // lower alpha (a-z)
      ) && 
      selectedCharacters.length < characterQuantity &&
      document.activeElement != hiddenInput
  ) {
    selectedCharacters.push({
      character: e.key.toUpperCase(),
      material: window.localStorage.getItem("charmMaterial"),
    });
  }
  
  setSelectedCharacters(selectedCharacters);
  renderCharms();
  renderAllCharacters();
  renderCart();
};

["keyup", "touchend"].forEach((eventName) => {
  document.addEventListener(eventName, handleTouchEvents);
});

function initStorage() {
  window.localStorage.setItem("chainLength", "5.5\"");
  window.localStorage.setItem("loopMaterial", "Yellow Gold");
  window.localStorage.setItem("charmMaterial", "Yellow Gold");
  window.localStorage.setItem("characterQuantity", "3");
  window.localStorage.setItem("currentStep", "step-1");
  window.localStorage.setItem("chainPrice", "0.00");
  setSelectedCharacters([]);
  
  renderChainImages();
  renderCart();
  renderPreview();
  renderAllCharacters();
}

function handleSelectTab(e) {
  setStep(e.target.dataset.stepName);
}

addEventListener("DOMContentLoaded", () => {
  const chainLengthSelectEls = document.querySelectorAll('.chain-length-select');
  chainLengthSelectEls.forEach((chainLengthSelectEl) => {
    chainLengthSelectEl.addEventListener('change', (e) => selectChainLength.call(chainLengthSelectEl, e.target.value));
  });
  
  const hiddenInput = document.querySelector("#chosen-letters-input");
  hiddenInput.addEventListener("input", (e) => {
    var selectedCharacters = getSelectedCharacters();
    const characterQuantity = parseInt(window.localStorage.getItem("characterQuantity"), 10);
    const character = e.data;
    const charCode = character && character.charCodeAt(0);

    if (
        (
          ALLOWED_NON_ALPHA_CHARACTERS.includes(character) ||
          (charCode > 64 && charCode < 91) || // upper alpha (A-Z)
          (charCode > 96 && charCode < 123) // lower alpha (a-z)
        ) && 
        selectedCharacters.length < characterQuantity
    ) {
      selectedCharacters.push({
        character: character.toUpperCase(),
        material: window.localStorage.getItem("charmMaterial"),
      });
    }
    
    hiddenInput.value = selectedCharacters.map((selectedCharacter) => {
      return selectedCharacter.character;
    }).join(',');
    
    setSelectedCharacters(selectedCharacters);
    renderCharms();
    renderAllCharacters();
    renderCart();
  });
  initChains(window.CHAINS);
  
  const selectedChainId = window.localStorage.getItem("productId");
  const initSelectedChainEl = document.querySelector("[data-product-id='" + selectedChainId + "']");
  if (initSelectedChainEl) {
    setTimeout(() => {
      initSelectedChainEl.click();
    }, 0)
  }
  
  var characterQuantity = parseInt(window.localStorage.getItem("characterQuantity"), 10);
  var chosenLettersEl = document.querySelector(".chosen-letters");
  if (chosenLettersEl) {
    renderCharacters(chosenLettersEl, "", characterQuantity)
  }
  renderCharacterQuantityValues();
  
  // init charms
  renderCharms();
  renderCharmMaterialSelections();

  // init tabs
  var tabs = document.querySelector("#Configurator ul");
  var tabLinks = document.querySelectorAll("#Configurator .tab-link");
  steps = {
    ...steps,
    step1: document.querySelector("#Configurator .contents .step-1"),
    step2: document.querySelector("#Configurator .contents .step-2"),
    step3: document.querySelector("#Configurator .contents .step-3"),
  };
  if (tabLinks) {
    tabLinks.forEach((tabLink) => {
      tabLink.addEventListener("click", handleSelectTab);
      tabLink.addEventListener("touchstart", handleSelectTab);
    });
  }
  
  var Configurator = document.getElementById("Configurator");
  if (location.hash !== '#builder') {
    if (Configurator) {
      Configurator.classList.add("hide");
      document.querySelector('[id$="section_custom_content_gjKFHM"][id^=shopify-section-template]').classList.remove("hide");
    }
  }
  if (location.hash === '#builder') {
    if (Configurator) {
      Configurator.classList.remove("hide");
      document.querySelector('[id$="section_custom_content_gjKFHM"][id^=shopify-section-template]').classList.add("hide");
    }
  }
  window.addEventListener("hashchange", (event) => {
    if (event && event.newURL) {
      var destination = new URL(event.newURL);
      if (destination.hash !== '#builder') {
        if (Configurator) {
          Configurator.classList.add("hide");
          document.querySelector('[id$="section_custom_content_gjKFHM"][id^=shopify-section-template]').classList.remove("hide");
        }
      }
      if (destination.hash === '#builder') {
        if (Configurator) {
          Configurator.classList.remove("hide");
          document.querySelector('[id$="section_custom_content_gjKFHM"][id^=shopify-section-template]').classList.add("hide");
          initStorage();
        }
      }
    }
  });
  
  var chains = document.querySelectorAll(".chain");
  if (chains) {
    chains.forEach((chain) => {
      chain.addEventListener("click", (e) => {
        const selectedChain = CHAIN_MAP[e.currentTarget.dataset.productId];
        const loopMaterials = [];
        if (selectedChain.title.includes("Yellow Gold")) {
          loopMaterials.push("Yellow Gold");
        } else if (selectedChain.title.includes("Rose Gold")) {
          loopMaterials.push("Rose Gold");
        } else if (selectedChain.title.includes("Silver")) {
          loopMaterials.push("Rose Gold");
          loopMaterials.push("Yellow Gold");
        }
        const previouslySelectedEls = document.querySelectorAll(".step-1 .selected, .step-2 .selected");
        if (previouslySelectedEls) {
          previouslySelectedEls.forEach((selectedEl) => {
            selectedEl.classList.remove("selected");
          });
        }
  
        const currentlySelectedSections = document.querySelectorAll("[data-product-id='" + selectedChain.id + "']");
        if (currentlySelectedSections) {
          currentlySelectedSections.forEach((selectedSection) => {
            const selectedChainLength = window.localStorage.getItem("chainLength");
            let selectedChainOptionEl;
            
            selectedSection.classList.add("selected");
            
            selectedChainOptionEl = selectedSection.querySelector("[data-chain-length='" + selectedChainLength + "']");
            if (selectedChainOptionEl) {
              selectChainLength.call(selectedChainOptionEl, selectedChainLength);
            }

            const loopMaterialEls = document.querySelectorAll('.loop-material-option');
            loopMaterialEls.forEach((loopMaterialEl) => {
              loopMaterialEl.classList.add('hide');
            });
            loopMaterials.forEach((loopMaterial) => {
              let loopMaterialEls = document.querySelectorAll(`.loop-material .option-value[data-loop-material="${loopMaterial}"]`);
              loopMaterialEls.forEach((loopMaterialEl) => {
                if (loopMaterialEl) {
                  loopMaterialEl.classList.remove('hide');
                }
              });
            });
            
            const loopMaterial = window.localStorage.getItem("loopMaterial");
            selectedChainOptionEl = selectedSection.querySelector(`.loop-material .option-value[data-loop-material="${loopMaterial}"]`);
            if (!selectedChainOptionEl) {
              selectedChainOptionEl = selectedSection.querySelector('.loop-material .option-value');
            }
            if (selectedChainOptionEl && selectedChainOptionEl.classList.contains('hide')) {
              let loopOptionEls = selectedSection.querySelectorAll('.loop-material .option-value');
              loopOptionEls.forEach((loopOptionEl) => {
                if (!loopOptionEl.classList.contains('hide')) {
                  selectedChainOptionEl = loopOptionEl;
                }
              })
            }
            if (selectedChainOptionEl) {
              selectLoopMaterial.call(selectedChainOptionEl, selectedChainOptionEl.dataset.loopMaterial);
            }
          });
        }
        
        window.localStorage.setItem("productId", e.currentTarget.dataset.productId);

        renderChainImages();
        renderCart();
        renderPreview();
      });
    });
  }
});

function selectChainLength(chainLength) {
  var previouslySelectedProduct = document.querySelectorAll(".chain-length .selected");
  if (previouslySelectedProduct) {
    previouslySelectedProduct.forEach((selectedSection) => {
      selectedSection.classList.remove("selected");
    });
  }
  this.classList.add("selected");
  window.localStorage.setItem("chainLength", chainLength);
        
  const customCartItemChainLengthEl = document.querySelector('.custom-cart-item-chain-length');
  if (customCartItemChainLengthEl) {
    customCartItemChainLengthEl.innerHTML = chainLength;
  }
  if (
      window.localStorage.getItem("productId") !== "" && 
      window.localStorage.getItem("chainMaterial") !== "" && 
      window.localStorage.getItem("chainLength") !== ""
  ) {
    var nextButton = document.querySelector(".next-button");
    if (nextButton) {
      nextButton.disabled = false;
    }
  }
  renderCart();
}

function selectLoopMaterial(loopMaterial) {
  var previouslySelectedProduct = document.querySelectorAll(".loop-material .selected");
  if (previouslySelectedProduct) {
    previouslySelectedProduct.forEach((selectedSection) => {
      selectedSection.classList.remove("selected");
    });
  }  
  
  const customCartItemLoopMaterialEl = document.querySelector('.custom-cart-item-loop-material');
  if (customCartItemLoopMaterialEl) {
    customCartItemLoopMaterialEl.innerHTML = loopMaterial;
  }
  
  this.classList.add("selected");
  window.localStorage.setItem("loopMaterial", loopMaterial);
  renderCart();
  renderAllCharacters();
}

function selectCharmMaterial(charmMaterial) {
  var previouslySelectedProduct = document.querySelectorAll(".charm-material.selected");
  if (previouslySelectedProduct) {
    previouslySelectedProduct.forEach((selectedSection) => {
      selectedSection.classList.remove("selected");
    });
  }
  
  this.classList.add("selected");
  window.localStorage.setItem("charmMaterial", charmMaterial);
  const selectedCharacters = getSelectedCharacters();
  setSelectedCharacters(selectedCharacters.map((selectedCharacter) => {
    if (!selectedCharacter.character.includes('gemstone')) {
      selectedCharacter.material = window.localStorage.getItem('charmMaterial');
    }

    return selectedCharacter;
  }));
  renderAllCharacters();
  renderCharms();
  renderCart();
}

function reset() {
  const currentStep = window.localStorage.getItem("currentStep");
  switch (currentStep) {
    case 'step-1':
      window.localStorage.setItem("chainLength", "5.5\"");
      const chainLengthSelect = document.querySelector('select.chain-length-select');
      if (chainLengthSelect) {
        chainLengthSelect.value = "5.5\"";
      }
      break;
    case 'step-2':
      window.localStorage.setItem("loopMaterial", "Yellow Gold");
      break;
    case 'step-3':
      window.localStorage.setItem("characterQuantity", "3");
      const characterQuantitySelect = document.querySelector('select.character-quantity-select');
      if (characterQuantitySelect) {
        characterQuantitySelect.value = "3";
      }
      setSelectedCharacters([]);
      renderAllCharacters();
      renderCharms();
      renderPreview();
      break;
  }
  
  var selectedDivs = document.querySelectorAll(`.${currentStep} .option-values .selected`);
  if (selectedDivs) {
    selectedDivs.forEach((selected) => {
      selected.classList.remove("selected");
    });
  }

  renderCart();
}

function setStep(step) {
  const currentStepTabLinkEl = document.querySelector('.tab-link.current');
  const nextButtons = document.querySelectorAll('.next-button');
  if (currentStepTabLinkEl) {
    currentStepTabLinkEl.classList.remove('current');
  }
  const currentStepContentEl = document.querySelector('.step.current');
  if (currentStepContentEl) {
    currentStepContentEl.classList.remove('current');
  }

  let currentTabEl = document.querySelector('.tab-link[data-step-name="' + step + '"]')
  currentTabEl.classList.add('current');
  
  switch(step) {
    case 'step-1':
      steps.step1.classList.add('current');
      nextButtons.forEach((nextButton) => {
        nextButton.innerHTML = "Next";
        nextButton.onclick = nextStep;
        nextButton.ontouchstart = nextStep;
        nextButton.disabled = false;
      });
      break;
    case 'step-2':
      steps.step2.classList.add('current');
      nextButtons.forEach((nextButton) => {
        nextButton.innerHTML = "Next";
        nextButton.onclick = nextStep;
        nextButton.ontouchstart = nextStep;
        nextButton.disabled = false;
      });
      break;
    case 'step-3':
      steps.step3.classList.add('current');
      nextButtons.forEach((nextButton) => {
        nextButton.innerHTML = "Buy Now";
        nextButton.onclick = addToCart;
        nextButton.ontouchstart = addToCart;
        if (canSubmit()) {
          nextButton.disabled = false;
        } else {
          nextButton.disabled = true;
        }
      });
      break;
  }
  
  if (isMobile()) {
    const scrollAreas = document.querySelectorAll('.products, .charm-materials .option-values');
    if (scrollAreas) {
      scrollAreas.forEach((scrollArea) => {
        scrollArea.scrollLeft = 75;
      });
    }
  }

  window.localStorage.setItem("currentStep", step);
}

function canSubmit() {
  const loopMaterial = window.localStorage.getItem("loopMaterial");
  const chainLength = window.localStorage.getItem("chainLength");
  const selectedCharacterCount = getSelectedCharacters().length;
  return getSelectedChainPrice() > 0 && getCharmPriceTotal() > 0 && selectedCharacterCount >= 3 && chainLength && loopMaterial;
}

function nextStep() {
  const currentStep = window.localStorage.getItem("currentStep");
  switch (currentStep) {
    case 'step-1':
      setStep('step-2');
      break;
    case 'step-2':
      setStep('step-3');
      break;
  }
}

function createRandomString(length) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const randomArray = new Uint8Array(length);
  crypto.getRandomValues(randomArray);
  randomArray.forEach((number) => {
    result += chars[number % chars.length];
  });
  return result;
}

function addOneItemToCart(talkingChainOrderId, items, index) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [items[index]],
    }),
  })
  .then(response => {
    response.json().then((response) => {
      if (items[index+1]) {
        addOneItemToCart(talkingChainOrderId, items, index+1);
      } else {
        const storedOrders = JSON.parse(window.localStorage.getItem('talkingChainOrders') || JSON.stringify({}));
        const newOrder = items.reduce((acc, item) => {
          return Object.assign({
            [item.id]: item.quantity
          }, acc);
        }, {
          orderQuantity: 1,
        });
        storedOrders[talkingChainOrderId] = newOrder;
        window.localStorage.setItem('talkingChainOrders', JSON.stringify(storedOrders));
        window.location = '/cart';
      }
    });
  })
  .catch((error) => {
    const addToCartButtonEl = document.querySelector('.custom-cart-submit');
    addToCartButtonEl.disabled = false;
    addToCartButtonEl.innerHTML = 'Buy now';
    if (window.localStorage.getItem("currentStep") === 'step-3') {
      const nextButtonEl = document.querySelector('.next-button');
      nextButtonEl.disabled = false;
      nextButtonEl.innerHTML = 'Buy now';
    }
    console.error(error);
  });
}

function addToCart() {
  const addToCartButtonEl = document.querySelector('.custom-cart-submit');
  addToCartButtonEl.innerHTML = 'Adding to cart...';
  addToCartButtonEl.disabled = true;
  if (window.localStorage.getItem("currentStep") === 'step-3') {
    const nextButtonEl = document.querySelector('.next-button');
    nextButtonEl.innerHTML = 'Adding to cart...';
    nextButtonEl.disabled = true;
  }
  const talkingChainOrderId = `${Date.now()}${createRandomString(10)}`
  const formData = {
   'items': [
      ...getCharmItems(talkingChainOrderId).reverse(),
      {
        'id': getSelectedLoop().variant_id,
        'quantity': 1,
        'properties': {
          'talking_chain_order_id': talkingChainOrderId
        }
      },
      {
        'id': getSelectedChain().variant_id,
        'quantity': 1,
        'properties': {
          'talking_chain_order_id': talkingChainOrderId
        }
      },
    ],
  };
  
  addOneItemToCart(talkingChainOrderId, formData.items, 0);

  return false;
}

function getCharmItems(talkingChainOrderId) {
  const charmItems = {};
  const selectedCharacters = getSelectedCharacters();
  return selectedCharacters.map((character, index) => {
    const position = (index === 0 ? "First" : (index === selectedCharacters.length - 1 ? "Last" : "Middle"));
    const lockLetterEl = document.querySelector('[data-lock-character="' + selectedCharacters[index].character + '"][data-lock-position="' + position + '"][data-charm-material="' + selectedCharacters[index].material + '"]');
    const productId = lockLetterEl.dataset.productId;
    const charmVariantId = [position,selectedCharacters[index].material,productId].join(",");
    const charmVariant = CHARM_VARIANT_MAP[charmVariantId];
    return {
      'id': charmVariant.variant_id,
      'quantity': 1,
      'properties': {
        'talking_chain_order_id': talkingChainOrderId,
        'charm_position': index + 1,
      }
    };
  });
}

function selectLock(e) {
  let selectedCharacters = getSelectedCharacters();
  let characterQuantity = window.localStorage.getItem("characterQuantity");
  if (selectedCharacters.length >= characterQuantity) {
    return;
  }
  selectedCharacters.push({
    character: e.currentTarget.dataset.lockCharacter,
    material: e.currentTarget.dataset.charmMaterial,
  });
  setSelectedCharacters(selectedCharacters);
  renderCharms();
  renderAllCharacters();
  renderCart();
}
